import React from "react";
import '../style/style.css';
import Header from "../../provider-header/components/index";

const SearchForm = () => {

  return (
    <>
    <Header />
    <div className="search_form">
        <div className="container">
            <div className="row">
                <div className="sarch_form_3">
                    <h2 className="text-center">SEARCH FORM</h2>
                </div>
                <form>
                    <div className="col-sm-12 space_all">
                        <div className="col-sm-12">
                            <div className="register_right">
                                <div className="register_right_inner clearfix" style={{ margin: "0 auto" }}>
                                    <div className="center_3">
                                        <div className="center_3 mb-4" style={{ fontSize: "23px", padding: "7px", borderRadius: "5px", textAlign: "center", background: "#cd3161" }}>
                                            <strong className="color text-center" style={{ color: "white" }}>Search Profile Details </strong><br />
                                        </div>
                                    </div>
                                    <div className="row mt-10 clear_1" style={{ marginTop: "15px" }}>
                                        <div className="col-sm-2 center_4">
                                            <p>Search By Name, Phone, City </p>
                                        </div>
                                        <div className="col-sm-4 ">
                                            <input type="text" className="input-text input_filter form-control" name="keyword" placeholder="Search By Name, Phone, City " />
                                        </div>
                                        <div className="col-sm-2 center_4">
                                            <p>Gender </p>
                                        </div>
                                        <div className="col-sm-4">
                                            <input type="radio" name="gender" id="male" />
                                            <label htmlFor="male">Male </label>
                                            <input type="radio" name="gender" id="female" />
                                            <label htmlFor="female">Female </label>
                                        </div>
                                    </div>
                                    <div className="row clear_1">
                                        <div className="col-sm-2 center_4">
                                            <p>Age </p>
                                        </div>
                                        <div className="col-sm-4">
                                            <select name="start_age" className="input-text dropdown_filter form-select">
                                                <option value="">Please Select </option>
                                                <option value="20">20</option>
                                                <option value="21">21</option>
                                                <option value="22">22</option>
                                                <option value="23">23</option>
                                                <option value="24">24</option>
                                                <option value="25">25</option>
                                                <option value="26">26</option>
                                                <option value="27">27</option>
                                                <option value="28">28</option>
                                                <option value="29">29</option>
                                                <option value="30">30</option>
                                                <option value="31">31</option>
                                                <option value="32">32</option>
                                                <option value="33">33</option>
                                                <option value="34">34</option>
                                                <option value="35">35</option>
                                                <option value="36">36</option>
                                                <option value="37">37</option>
                                                <option value="38">38</option>
                                                <option value="39">39</option>
                                                <option value="40">40</option>
                                                <option value="41">41</option>
                                                <option value="42">42</option>
                                                <option value="43">43</option>
                                                <option value="44">44</option>
                                                <option value="45">45</option>
                                                <option value="46">46</option>
                                                <option value="47">47</option>
                                                <option value="48">48</option>
                                                <option value="49">49</option>
                                                <option value="50">50</option>
                                            </select>
                                        </div>
                                        <div className="col-sm-2 center_4">
                                            <p>To </p>
                                        </div>
                                        <div className="col-sm-4">
                                            <select name="end_age" className="input-text dropdown_filter form-select">
                                                <option value="">Please Select </option>
                                                <option value="20">20</option>
                                                <option value="21">21</option>
                                                <option value="22">22</option>
                                                <option value="23">23</option>
                                                <option value="24">24</option>
                                                <option value="25">25</option>
                                                <option value="26">26</option>
                                                <option value="27">27</option>
                                                <option value="28">28</option>
                                                <option value="29">29</option>
                                                <option value="30">30</option>
                                                <option value="31">31</option>
                                                <option value="32">32</option>
                                                <option value="33">33</option>
                                                <option value="34">34</option>
                                                <option value="35">35</option>
                                                <option value="36">36</option>
                                                <option value="37">37</option>
                                                <option value="38">38</option>
                                                <option value="39">39</option>
                                                <option value="40">40</option>
                                                <option value="41">41</option>
                                                <option value="42">42</option>
                                                <option value="43">43</option>
                                                <option value="44">44</option>
                                                <option value="45">45</option>
                                                <option value="46">46</option>
                                                <option value="47">47</option>
                                                <option value="48">48</option>
                                                <option value="49">49</option>
                                                <option value="50">50</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="row clear_1 mt-2" bis_skin_checked="1">
                                        <div className="col-sm-2 center_4" bis_skin_checked="1">
                                            <p>Income </p>
                                        </div>
                                        <div className="col-sm-4" bis_skin_checked="1">
                                            <select name="income" id="" className="input-text dropdown_filter form-select">
                                                <option value="">Please Select</option>
                                                <option value="0-0">Not Applicable</option>
                                                <option value="20000-50000">Rs 20000 to 50000</option>
                                                <option value="50000-100000">Rs 50000 to 1 lakh</option>
                                                <option value="100000-150000">Rs 1 lakh to 1.5 lakh</option>
                                                <option value="150000-200000">Rs 1.5 lakh to 2 lakh</option>
                                                <option value="200000-250000">Rs 2 lakh to 2.5 lakh</option>
                                                <option value="250000-300000">Rs 2.5 lakh to 3 lakh</option>
                                                <option value="300000-400000000">Rs 3 lakh and above</option>
                                            </select>
                                        </div>
                                        <div className="col-sm-2 center_4" bis_skin_checked="1">
                                            <p>Religion </p>
                                        </div>
                                        <div className="col-sm-4" bis_skin_checked="1">
                                            <select name="religion_id" id="" className="input-text dropdown_filter form-select">
                                                <option value="">Please Select </option>
                                                <option value="1">Muslim</option>
                                                <option value="2">Hindu</option>
                                                <option value="3">Christian</option>
                                                <option value="4">Sikh</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    </>
  );
};

export default SearchForm;
